import imodeler_logo from '../../../img/imodeler.png';
import shimakaze_img from '../../../img/shimakaze.jpg';

export default function Shimakaze(props) {

    
    let shima_es = (<div>Construí un Shimakaze escala 1:700. El proyecto está descrito en imodeler, para leer el artículo <a href="https://imodeler.com/2019/11/pit-road-ijn-shimakaze-1943-1700/" target="_blank" rel="noreferrer">haz click aquí</a>
    <center><img src={shimakaze_img} class="article-img" alt="Shimakaze"/></center>
    </div>);
    let shima_en = (<div>I built a 1:700 scale Shimakaze. The project is in imodeler, to read the article <a href="https://imodeler.com/2019/11/pit-road-ijn-shimakaze-1943-1700/" target="_blank" rel="noreferrer">click here</a>
        <center><img src={shimakaze_img} class="article-img" alt="Shimakaze"/></center>
        </div>);
    let shima = shima_es;

    switch(props.lang){
        case "en":
            shima = shima_en;
        default:
            break;
    }

    return (
        <article className='article' name='imodeler'>
            <a href='https://www.imodeler.com/members/alfredo_cofre/' target='_blank' rel='noreferrer'>
                <img src={imodeler_logo} width="32px" alt="imodeler"/>
            </a>
            {shima}
        </article>);
}